"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductionHistoryColumnProps = exports.ProductionColumnProps = void 0;
const constants_1 = require("utils/constants");
const ProductionColumnProps = [
    // {
    //   show:true,
    //   field:'contractor',
    //   title:'Contractor',
    //   width:'200',
    //   filter:'text',
    // },
    // {
    //   show:true,
    //   field:'brand',
    //   title:'Brand',
    //   width:'150',
    //   filter:'text',
    // },
    // {
    //   show:true,
    //   field:'area',
    //   title:'Area',
    //   width:'150',
    //   filter:'text',
    // },
    {
        show: true,
        field: 'jan',
        title: 'Jan',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'feb',
        title: 'Feb',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'mar',
        title: 'Mar',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'apr',
        title: 'Apr',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'may',
        title: 'May',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'jun',
        title: 'Jun',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'jul',
        title: 'Jul',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'aug',
        title: 'Aug',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'sep',
        title: 'Sep',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'oct',
        title: 'Oct',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'nov',
        title: 'Nov',
        width: '100',
        filter: 'text'
    },
    {
        show: true,
        field: 'dec',
        title: 'Dec',
        width: '100',
        filter: 'text'
    }
];
exports.ProductionColumnProps = ProductionColumnProps;
const ProductionHistoryColumnProps = [
    {
        show: true,
        field: 'action',
        title: 'Action',
        width: '75',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'filename',
        title: 'File Name',
        width: '300',
        filter: 'text',
    },
    {
        show: true,
        field: 'year',
        title: 'Year',
        width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'status',
        title: 'Status',
        width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'log_message',
        title: 'Log',
        width: '110',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'uploaded_at',
        title: 'Uploaded At',
        width: '175px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'uploaded_by',
        title: 'Uploaded by',
        width: '175px',
        filter: 'text'
    },
];
exports.ProductionHistoryColumnProps = ProductionHistoryColumnProps;
